// Param descriptors. Every field / substrate / mark module declares its own,
// and ControlRack renders the panel from them. Adding a new generator type
// costs one file and zero panel edits — which is the difference between a
// panel that reaches five generators and one that reaches eighty-one.

// Cost of change, which is what the user actually feels:
//   structural — rebuild (dropdowns)
//   continuous — live at 60fps (sliders)
//   cosmetic   — render-only, cheapest
//   identity   — discrete (seed, layers)
export const TIERS = ['structural', 'continuous', 'cosmetic', 'identity']

export function defaults(params) {
  const out = {}
  for (const p of params) out[p.key] = p.default
  return out
}

// A descriptor already states everything needed to validate its own value —
// the option list for an enum, the range for a slider — so validation is read
// from the schema rather than written out again somewhere else.
//
// This matters because a piece spec is no longer always ours: it can arrive
// from a URL fragment, which anyone can hand-edit. Out-of-range numbers are
// clamped rather than rejected so a slightly-off link still opens.
function coerce(param, value) {
  if (value === undefined) return param.default
  if (param.type === 'enum') {
    return param.options.some((o) => o.value === value) ? value : param.default
  }
  if (param.type === 'text') {
    return typeof value === 'string' ? value : param.default
  }
  const n = Number(value)
  if (!Number.isFinite(n)) return param.default
  if (param.min === undefined) return n
  return Math.min(param.max, Math.max(param.min, n))
}

// Takes only the keys the schema declares. Dropping the rest is what keeps a
// hand-edited fragment from smuggling an unresolvable `type` past the
// fallback in normalise() and crashing the engine downstream.
export function withDefaults(params, cfg) {
  const out = {}
  const src = cfg && typeof cfg === 'object' ? cfg : {}
  for (const p of params) out[p.key] = coerce(p, src[p.key])
  return out
}
